// wizard step 1 of CreateDisplayConceptModal
import React from 'react';
import { Modal, ErrorBanner, Layout, Button, ReduxControls } from 'rhombus-react';
import { reduxForm, Field, isDirty, isInvalid } from 'redux-form';
import {
	conceptNameAllowedChars,
	conceptNameExists,
	openConceptNameMaxLength,
	OPEN_CONCEPT_NAME_MAX_LENGTH
} from 'widgets/forms/validators/Concepts';
import { useSelector } from 'react-redux';
import useAdvanceWizard from 'hooks/useAdvanceWizard';
import { allErrorsSelector } from 'widgets/forms/validators/Social';
import { CONCEPT_NAME } from "forms/list";
import { HTML_CONCEPT_TYPE } from 'utils/constants';
import { required } from 'widgets/forms/validators/validators';

export function ConceptNameBanner(props){
	const {
		Breadcrumb,
		navigationActions: { closeModal, stepForward },
		commonModalProps,
		formName,
	} = props;

	const messages = useSelector(allErrorsSelector(formName));
	const isFormDirty = useSelector(isDirty(formName));
	const invalid = useSelector(isInvalid(formName));

	const [attemptAdvance, isAttemptingAdvance] = useAdvanceWizard(CONCEPT_NAME, stepForward);

	function renderContent() {
		return (
			<div className="c-modal-content">
				{Breadcrumb}
				<div className="c-modal-body">
					{(isFormDirty && messages.length) ? <ErrorBanner title="Sorry, please fix the errors below and try again."
						messages={messages} /> : "" }
					<div className="form-field">
						<Field component={ReduxControls.Input}
							required
							label="Concept Name"
							name="conceptName"
							autoFocus
							className={messages.length ? "error" : ""}
							validate={[required, openConceptNameMaxLength, conceptNameAllowedChars]}
							charMax={OPEN_CONCEPT_NAME_MAX_LENGTH}
							showCharCount
						/>
					</div>
				</div>
			</div>
		);
	}

	function renderFooter() {
		return (
			<Layout.ModalFooter>
				<Button theme="default" onClick={closeModal}>Cancel</Button>
				<Button theme="blue" disabled={invalid || isAttemptingAdvance} onClick={attemptAdvance}>Next to Add Creative</Button>
			</Layout.ModalFooter>
		);
	}

	const modalProps = {
		...commonModalProps,
		renderContent,
		renderFooter,
	};

	return <Modal {...modalProps} />;
}

function asyncConceptName(values, dispatch, props){
	const conceptName = values?.conceptName;
	const { libraryId } = props.commonModalProps;

	return conceptNameExists(dispatch, libraryId, conceptName, HTML_CONCEPT_TYPE);
}

ConceptNameBanner.displayName = "ConceptNamePane";

const formWrapper = reduxForm({
	form: CONCEPT_NAME,
	destroyOnUnmount: false,
	asyncValidate: asyncConceptName,
	asyncBlurFields: ["conceptName"],
});

export default formWrapper(ConceptNameBanner);
